import script from "./AppsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppsPage.vue?vue&type=script&setup=true&lang=ts"

import "./AppsPage.vue?vue&type=style&index=0&id=59cf09d2&lang=scss"

const __exports__ = script;

export default __exports__